import React from "react";
import TabList from "./TabList";
import TabCircles from "./TabCircles";

export default props => (
    <div className="instruction-header">
        <div className="instruction-header-col-1">
        <h1>Instructions<br />&amp;&nbsp;Practice</h1>
        </div>
        <div className="instruction-header-col-2">
            <TabList currentTabId={props.currentTabId} elems={props.elems} />
            <TabCircles length={props.elems.length} currentTabId={props.currentTabId} circleClick={props.circleClick} />
        </div>
    </div>
);
